import { theme } from "../theme/css/theme.css";

type TransitionProperty =
  | string
  | { property: string; duration?: string; ease?: string; delay?: string };

/**
 * Returns a transition string for the given properties.
 */
export function transition(...properties: TransitionProperty[]): string {
  return (
    properties
      ?.map((item) => {
        if (typeof item === "string") {
          return `${item} ${theme.transition.duration.s} ${theme.transition.ease}`;
        } else if (typeof item === "object") {
          const duration = item?.duration || theme.transition.duration.s;
          const ease = item?.ease || theme.transition.ease;
          const delay = item?.delay || "0s";

          return `${item.property} ${duration} ${ease} ${delay}`;
        }

        return "";
      })
      .join(", ") ?? ""
  );
}
